module.exports = __webpack_public_path__ + "static/media/1-circle-available.91c7a306.svg";